const redirectPages = (
  config,
  createPage,
  redirectPageTemplate,
  contextProps
) => {
  return config.forEach(data => {
    createPage({
      path: data.url,
      component: redirectPageTemplate,
      context: {
        redirect: data.redirect,
        ...contextProps,
      },
    })
  })
}

const getPagePath = ({ to, sitePages, sectionId }) => {
  const isLinkAPopup = sectionId?.includes("popups")
  if (to) {
    let pagePath
    if (typeof to === "number") {
      const pagesDict = {}
      sitePages.forEach(page => {
        const pageId = page.pageContext?.pageId
        if (pageId) pagesDict[pageId] = page.path
      })
      pagePath = pagesDict[to]
    } else if (typeof to === "string") {
      pagePath = to
    }
    if (sectionId && !isLinkAPopup) {
      pagePath = pagePath + "#" + sectionId
    }
    return pagePath
  }
  return null
}

module.exports = {
  redirectPages,
  getPagePath,
}
